module.exports = __webpack_public_path__ + "media/11_5.8dd8ed5a.wav";